'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired);
/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackDiscardSlipButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_DISCARD_SLIP_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_DISCARD_SLIP_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackDiscardSlipButtonClick;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackDiscardSlipButtonClick.js
// module id = 1009
// module chunks = 0